import { createSelector } from '@ngrx/store';
import { PlansState } from 'src/app/core/store/plans/plans.reducer';
import { selectPlansState } from '../../reducers';

export const plans = createSelector(selectPlansState, (state: PlansState) => {
  return {
    plans: state.plans,
    pagerResponse: state.pagerResponse,
  };
});

export const plan = createSelector(selectPlansState, (state: PlansState) => {
  return {
    plan: state.plan,
  };
});
